import React from 'react'
import Icon from '../../atoms/Icon/Icon'
import { getIcon } from 'app/app/(client)/utils/utils'

interface InformationBannerProps {
  id?: string
  message: string | React.ReactNode
  type: 'success' | 'error' | 'info' | 'warning'
  className?: string
}

const InformationBanner: React.FC<InformationBannerProps> = ({ id, message, type = 'info', className }) => {
  const iconClassName = () => {
    switch (type) {
      case 'success':
        return 'text-badge-success'
      case 'error':
        return 'text-badge-error'
      case 'info':
        return 'text-badge-normal'
      case 'warning':
        return 'text-badge-warning'
      default:
        return 'text-badge-info'
    }
  }

  const mainContainerTypeClassName = () => {
    switch (type) {
      case 'success':
        return 'bg-background-badge-success'
      case 'error':
        return 'bg-background-badge-error'
      case 'info':
        return 'bg-background-badge-normal'
      case 'warning':
        return 'bg-background-badge-warning'
      default:
        return 'bg-background-badge-info'
    }
  }

  return (
    <div
      id={id}
      className={`flex items-center gap-2 px-3 py-2 self-stretch rounded-lg ${mainContainerTypeClassName()} mb-2 ${className}`}
    >
      <Icon name={getIcon(type)} className={`${iconClassName()} text-badge text-[20px]`} />
      {message}
    </div>
  )
}

export default InformationBanner
